import React from 'react';
import './App.css';
import { Paper, Typography } from "@material-ui/core"
import Soundboard from "./Soundboard";

const App: React.FC = () => {

  return (
    <div className="Pekka Siitoin Soundboard">
      <Paper elevation={1}
        style={{
          height: "100%"
        }}
      >
        <Paper elevation={2}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around"
          }}
        >
          <Paper
            style={{
              display: "flex",
              flexGrow: 1
            }}
          >
            <img src={"pekka-vasen.jpg"} />
          </Paper>
          <Paper
            style={{
              display: "flex",
              flexGrow: 666
            }}
          >
            <Typography
              variant="h2"
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

              }}>
              Pekka Siitoin Soundboard
          </Typography>
          </Paper>
          <Paper
            style={{
              display: "flex",
              flexGrow: 1
            }}
          >
            <img src={"pekka-oikea.jpg"} />
          </Paper>
        </Paper>
        <Soundboard />
        <Paper style={{ height: "2rem" }} />
        <Paper elevation={2}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              width: "80%"
            }}
          >
            <Typography variant="h6">
              Mikä?
          </Typography>
            <Typography variant="body1">
              Pekka Siitoin Soundboard
          </Typography>
            <Typography variant="h6">
              Kuka?
          </Typography>
            <Typography variant="body1">
              Pekka Siitoin. <a href="https://fi.wikipedia.org/wiki/Pekka_Siitoin">Wikipedia</a>
            </Typography>
            <Typography variant="h6">
              Miksi?
          </Typography>
            <Typography variant="body1">
              Alkuperäinen soundboard katosi netistä, katsoin kulttuurihistoriallisesti tärkeäksi tehdä se uusiksi. Tässä on samat äänipätkät kuin alkuperäisessä, kiitoksia sen tekijälle.
          </Typography>
            <Typography variant="h6">
              Millä?
          </Typography>
            <Typography variant="body1">
              Reactilla ja TypeScriptillä. Kun perinteisillä keinoilla tulee liian kevyitä sivuja. Mutta pitäisi toimia kaikilla moderneilla selaimilla (Safaria ei lasketa). Ongelmat ja ehdotukset voi lähettää ignoroitavaksi osoitteeseen marras@snakebearer.net
          </Typography>
          <Typography variant="h6">
            Bonus: 
          </Typography>
          <Typography variant="body1">
            Pekka-versioita Venomin biiseistä:
            <br/>
            <a href="https://www.youtube.com/watch?v=eplB1XTWoHQ">In League With Satan - Hiljaa, nyt puhuu Siitoin!</a>
            <br/>
            <a href="https://www.youtube.com/watch?v=SPDUAm8L9IE">Welcome to Hell - Tervetuloa Naantaliin!</a>
            <br/>
            <a href="https://www.youtube.com/watch?v=lvImeHy6nJY">Countess Bathory - Musta Raamattu</a>
          </Typography>
          </div>
        </Paper>
      </Paper>
    </div>
  );
}

export default App;
